export enum DeliveryDatesActionTypes {
  GET_DELIVERY_AVAILABLE_DATE = 'GET_DELIVERY_AVAILABLE_DATE',
  FETCH_NOTIFICATION_EXCEPTION = 'FETCH_NOTIFICATION_EXCEPTION',
  SET_FETCHED_NOTIFICATION_EXCEPTION = 'SET_FETCHED_NOTIFICATION_EXCEPTION'
}
